document.addEventListener("DOMContentLoaded", function () {
    function initSwiper() {
      if (window.innerWidth < 768) {
    const list = document.querySelector('.jdgm-review-list');

    if (!list || list.classList.contains('swiper-initialized')) return;

    // Add swiper container
    list.classList.add('swiper');

    // Create wrapper
    const wrapper = document.createElement('div');
    wrapper.className = 'swiper-wrapper';

    [...list.children].forEach(item => {
      if (item.classList.contains('jm-review-item')) {
        item.classList.add('swiper-slide');
        wrapper.appendChild(item);
      }
    });

    list.innerHTML = '';
    list.appendChild(wrapper);

    // Pagination (progress bar)
    const pagination = document.createElement('div');
    pagination.className = 'swiper-pagination';
    list.appendChild(pagination);

      new Swiper(list, {
        slidesPerView: 1.3,
        spaceBetween: 16,
        loop: true,
        pagination: {
          el: pagination,
          type: 'progressbar'
        }
      });
    }
  }

  // Observe Judge.me DOM changes
  const observer = new MutationObserver(() => {
    if (document.querySelector('.jm-review-item')) {
      initSwiper();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});


document.addEventListener('DOMContentLoaded', () => {
  const sliderComponent = document.querySelector('slider-component');
  if (!sliderComponent) return;

  const slider = sliderComponent.querySelector('.slider');
  const slides = slider.querySelectorAll('li');
  const buttons = sliderComponent.querySelector('.slider-buttons');
  if (!slider || !buttons) return;

  const dotsWrapper = document.createElement('div');
  dotsWrapper.className = 'slider-dots';

  slides.forEach((slide, index) => {
    const dot = document.createElement('div');
    dot.className = 'slider-dot';
    if (index === 0) dot.classList.add('active');

    dot.addEventListener('click', () => {
      slider.scrollTo({
        left: slide.offsetLeft,
        behavior: 'smooth'
      });
    });

    dotsWrapper.appendChild(dot);
  });

  buttons.appendChild(dotsWrapper);

  // ✅ Update active dot on scroll (Dawn-safe)
  slider.addEventListener('scroll', () => {
    const index = Math.round(slider.scrollLeft / slider.offsetWidth);
    dotsWrapper.querySelectorAll('.slider-dot').forEach((dot, i) => {
      dot.classList.toggle('active', i === index);
    });
  });
});


document.querySelectorAll('details').forEach((details) => {
  const summary = details.querySelector('summary');
  const content = details.querySelector('.accordion__content');

  summary.addEventListener('click', (e) => {
    e.preventDefault();

    if (details.open) {
      // Closing
      const height = content.offsetHeight;
      content.style.height = height + 'px';

      requestAnimationFrame(() => {
        content.style.height = '0px';
      });

      content.addEventListener(
        'transitionend',
        () => {
          details.open = false;
          content.style.height = '';
        },
        { once: true }
      );
    } else {
      // Opening
      details.open = true;
      const height = content.scrollHeight;
      content.style.height = '0px';

      requestAnimationFrame(() => {
        content.style.height = height + 'px';
      });

      content.addEventListener(
        'transitionend',
        () => {
          content.style.height = '';
        },
        { once: true }
      );
    }
  });
});